import { render, staticRenderFns } from "./order_zh.vue?vue&type=template&id=430c58bb&scoped=true"
import script from "./order_zh.vue?vue&type=script&lang=js"
export * from "./order_zh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430c58bb",
  null
  
)

export default component.exports